import React from "react";
import PropTypes from "prop-types";

/**
 * CardActions - Action buttons area with hover animations
 * Automatically handles show/hide behavior on desktop hover
 * Always visible on mobile and when in editing mode
 * 
 * @component
 * @example
 * <CardActions isEditing={false}>
 *   <ActionButtons onEdit={handleEdit} onDelete={handleDelete} />
 * </CardActions>
 */
const CardActions = ({
    children,
    isEditing = false,
    className = "",
}) => {
    return (
        <div
            className={`
        px-3 mt-auto transition-all duration-300 ease-in-out overflow-hidden
        ${isEditing
                    ? "max-h-20 opacity-100"
                    : "max-h-20 opacity-100 lg:max-h-0 lg:opacity-0 lg:group-hover:max-h-20 lg:group-hover:opacity-100"
                }
        ${className}
      `}
            onClick={(e) => e.stopPropagation()}
        >
            {children}
        </div>
    );
};

CardActions.propTypes = {
    children: PropTypes.node.isRequired,
    isEditing: PropTypes.bool,
    className: PropTypes.string,
};

export default CardActions;
